import FaceSelector from './src/main';

/* istanbul ignore next */
FaceSelector.install = function(Vue) {
  Vue.component(FaceSelector.name, FaceSelector);
};

export default FaceSelector;
